import { localize } from "render/context/InternationalizationContext";

const Title = localize({
  en_GB: <>You are all set and ready to get scanned.</>,
  sv_SE: <>Tack, du är redo för din undersökning på Atrium Vårdcentral.</>,
});

export const Trans = { Title };
